export const examTypes = [
    "TYT–AYT",
    "LGS",
    "YDT",
    "KPSS",
    "ALES",
    "DGS",
    "MSÜ",
    "TUS",
    "YÖS",
    "DUS",
    "TOEFL",
    "IELTS",
    "POMEM",
  ];
  
  export const examLessons = {
    "TYT–AYT": [
      { name: "Türkçe", totalQuestions: 40 },
      { name: "Matematik", totalQuestions: 40 },
      { name: "Fen Bilimleri", totalQuestions: 40 },
      { name: "Sosyal Bilimler", totalQuestions: 40 },
      { name: "Edebiyat", totalQuestions: 40 },
    ],
    LGS: [
      { name: "Türkçe", totalQuestions: 20 },
      { name: "Matematik", totalQuestions: 20 },
      { name: "Fen Bilimleri", totalQuestions: 20 },
      { name: "Sosyal Bilimler", totalQuestions: 20 },
      { name: "İngilizce", totalQuestions: 10 },
    ],
    YDT: [
      { name: "Dil Bilgisi", totalQuestions: 20 },
      { name: "Okuma", totalQuestions: 20 },
      { name: "Kelime Bilgisi", totalQuestions: 20 },
      { name: "Cloze Test", totalQuestions: 10 },
      { name: "Çeviri", totalQuestions: 10 },
    ],
    KPSS: [
      { name: "Türkçe", totalQuestions: 30 },
      { name: "Matematik", totalQuestions: 30 },
      { name: "Tarih", totalQuestions: 30 },
      { name: "Coğrafya", totalQuestions: 18 },
      { name: "Vatandaşlık", totalQuestions: 12 },
    ],
    ALES: [
      { name: "Sayısal Yetenek", totalQuestions: 50 },
      { name: "Sözel Yetenek", totalQuestions: 50 },
      { name: "Mantık", totalQuestions: 20 },
    ],
    DGS: [
      { name: "Sayısal Yetenek", totalQuestions: 60 },
      { name: "Sözel Yetenek", totalQuestions: 60 },
      { name: "Matematik", totalQuestions: 40 },
      { name: "Türkçe", totalQuestions: 40 },
      { name: "Mantık", totalQuestions: 20 },
    ],
    MSÜ: [
      { name: "Türkçe", totalQuestions: 40 },
      { name: "Matematik", totalQuestions: 40 },
      { name: "Fen Bilimleri", totalQuestions: 20 },
      { name: "Sosyal Bilimler", totalQuestions: 20 },
      { name: "Genel Yetenek", totalQuestions: 40 },
    ],
    TUS: [
      { name: "Temel Tıp Bilimleri", totalQuestions: 120 },
      { name: "Klinik Tıp Bilimleri", totalQuestions: 120 },
    ],
    YÖS: [
      { name: "Matematik", totalQuestions: 40 },
      { name: "Geometri", totalQuestions: 30 },
      { name: "IQ ve Mantık", totalQuestions: 30 },
    ],
    DUS: [
      { name: "Diş Hekimliği Temel Bilimler", totalQuestions: 100 },
      { name: "Klinik Diş Hekimliği", totalQuestions: 100 },
    ],
    TOEFL: [
      { name: "Reading", totalQuestions: 30 },
      { name: "Listening", totalQuestions: 30 },
      { name: "Speaking", totalQuestions: 4 },
      { name: "Writing", totalQuestions: 2 },
    ],
    IELTS: [
      { name: "Listening", totalQuestions: 40 },
      { name: "Reading", totalQuestions: 40 },
      { name: "Writing", totalQuestions: 2 },
      { name: "Speaking", totalQuestions: 3 },
    ],
    POMEM: [
      { name: "Türkçe", totalQuestions: 20 },
      { name: "Matematik", totalQuestions: 20 },
      { name: "Genel Kültür", totalQuestions: 30 },
      { name: "Anayasa ve Kanunlar", totalQuestions: 10 },
    ],
  };
  
  export const getUserTitle = (username) => {
    if (!username) return "";
    return `${username}'nin Dünyası`;
  };